import { useCallback, useState } from 'react'
import "./case_category.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { useNavigate } from 'react-router-dom';

const addCaseCategoryEndpoint = ApiEndpoints.caseCategory.caseCategoryCreate;
export default function AddCaseCategory() {

  const navigate = useNavigate();
  const [postData, setPostData] = useState({
    name: "",
    image: null,
    alt_image: "",
  });
  const [preview, setPreview] = useState(null);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    // File input
    if (files && files.length > 0) {
      const file = files[0];

      setPostData((prev) => ({
        ...prev,
        [name]: file,
      }));

      // image preview
      setPreview(URL.createObjectURL(file));
    }
    // Text input
    else {
      setPostData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    try {

      const formData = new FormData();
      Object.entries(postData).forEach(([key, value]) => {
        formData.append(key, value);
      });

      await ApiRequest("POST", addCaseCategoryEndpoint, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      navigate("/admin/case-category");
    } catch (error) {
      console.error("There was an error creating the author!", error);
    }
  };

  return (
    <>
      <div className="header-add-category">
        <h5>Add Case Category</h5>
      </div>
      <div className="add-mediacat-content">
        <form onSubmit={handleSubmit}>
          <div className="row">

            {/* Title Input */}
            <div className="col-md-12">
              <label>Case Category:*</label>
              <input
                type="text"
                name='name'
                value={postData.name}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            <div className="col-md-12">
              <label>Image (336 × 306 Px):*</label>
              <input
                type="file"
                name='image'
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            {preview && (
              <div className="mt-2">
                <img
                  src={preview}
                  alt="Preview"
                  style={{ width: "150px", borderRadius: "6px" }}
                />
              </div>
            )}

            <div className="col-md-12">
              <label>Alt Image:*</label>
              <input
                type="text"
                name='alt_image'
                value={postData.alt_image}
                onChange={handleChange}
                required
                className="form-control"
              />
            </div>

            {/* Submit Button */}
            <div className="col-md-12">
              <button type="submit" className="btn btn-primary submit-formbtn">
                add case category
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}
